<template>
    <div class="row gy-2">
        <div class="col-12">
            <h5 class="mb-3">List of payrolls</h5>
            <div class="row mb-3 gy-2 justify-content-between">
                <div class="col-md-6 col-lg-4 d-flex">
                    <div class="input-group w-auto">
                        <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage"
                            :options="pageOptions"></b-form-select>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="input-group mb-0 justify-content-md-end">
                        <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenu2"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="ri ri-filter-2-line align-bottom"></i> <span
                                class="d-none d-sm-inline">Filters</span>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                            <div class="p-3">
                                <!-- <label class="form-label">Status </label>
                                <select v-model="queryFilters.status" class="form-select"
                                    @change="fetchItems();">
                                    <option value="">-- Any -</option>
                                    <option v-for="(option, uIndex) in statusOptions" :key="uIndex" :value="option.value">
                                        {{ option.label }}</option>
                                </select>
                                <hr class="border-0 dropdown-divider"> -->

                                <label class="form-label">
                                    Year/Month
                                </label>
                                <div class="input-group">
                                    <select @change="queryFilters.month = ''; fetchItems();" v-model="queryFilters.year"
                                        class="form-select">
                                        <option value="">-- Any --</option>
                                        <option v-for="(year, yIndex) in yearOptions" :key="yIndex" :value="year.value">{{ year.label }}</option>
                                    </select>
                                    <select v-model="queryFilters.month"
                                        class="form-select" @change="fetchItems();">
                                        <option value="">-- Any --</option>
                                        <option v-for="(month, mIndex) in monthOptions" :key="mIndex" :value="month.value">{{ month.label }}</option>
                                    </select>
                                </div>
                                <div class="pt-3">
                                    <button @click="queryFilters = {}" class="btn btn-sm p-0 btn-link"
                                        type="button"><span class="mdi mdi-close"></span> Clear</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <p class="mb-0">Showing {{ paginationInfo }} results</p>
            </div>
            <div class="card mb-0">
                <div class="card-body p-3">
                    <div class="table-responsive mb-0 loading-viewport">
                        <CommonSpinner v-if="isLoading" :box="true" />
                        <b-table striped hover ref="selectableTable" :items="pageData.data" :fields="columns"
                            responsive="sm" align="middle">
                            <template v-for="(column, colIndex) in columns.filter((i) => i.sortable)"
                                v-slot:[`head(${column.key})`]>
                                <div :key="colIndex" @click="setSortOrder(column)" class="cursor-pointer
                                    d-flex align-items-center">
                                    {{ column.label }} <span v-html="getSortingLabel(column.key)"></span>
                                </div>
                            </template>
                            <template v-slot:head(check)>
                                <div style="width:3.5rem;" class="form-check text-center">
                                    <label class="form-check-label me-2" for="tableSRadioHead">
                                        <input @change="selectAllRows($event)" type="checkbox" class="form-check-input"
                                            id="tableSRadioHead" />
                                    </label>
                                </div>
                            </template>
                            <template v-slot:cell(check)="data">
                                <div style="width:3.5rem;" class="form-check text-center me-auto">
                                    <input v-model="selectedItems" type="checkbox" :value="data.item.id"
                                        class="form-check-input me-2" :id="`tableSRadio${data.item.id}`"
                                        @click="handleCheckboxClick($event, data.item)" />
                                    <label class="form-check-label" :for="`tableSRadio${data.item.id}`"></label>
                                </div>
                            </template>
                            <template v-for="(column, colIndex) in columns.filter((i) => i.auto)"
                                v-slot:[`cell(${column.key})`]="data">
                                <div @click="navigateTo(data.item.id)" :key="colIndex"
                                    :style="{ 'width': `${column.width || '7'}rem` }"
                                    class="cursor-pointer d-flex align-items-center">
                                    <CommonTableTemplate :item="data.item" :column="column" />
                                </div>
                            </template>
                            <template v-slot:cell(action)="data">
                                <div style="min-width: 6rem;">
                                    <button  class="btn btn-primary btn-sm" @click="navigateTo(data.item.id)">View More</button>
                                </div>
                            </template>
                        </b-table>
                        <p v-if="!isLoading && !pageData.data.length" class="text-center text-muted">No payrolls to show
                        </p>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <b-pagination v-model="currentPage" :limit="pageLimit" class="pagination-rounded"
                    :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { commonSortingMixin } from '@shared/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@shared/mixins/commonPaginationMixin';
import { commonSelectRowMixin } from '@shared/mixins/commonSelectRowMixin';

export default {
    name: "employee-payrolls",
    mixins: [
        commonSortingMixin,
        commonPaginationMixin,
        commonSelectRowMixin
    ],
    data() {
        return {
            isLoading: false,
            searchQuery: "",
            queryFilters: {
                status: "",
                year: "",
                month: ""
            },
            statusOptions: [
                { value: "pending", label: "Pending" },
                { value: "approved", label: "Approved" },
                { value: "processed", label: "Processed" },
            ],
            columns: [
                "action",
                { key: "year", width: 5, auto: true, label: "Year" },
                { key: "month", width: 5, auto: true, label: "Month" },
                { key: "basic_salary", width: 8, auto: true, label: "Basic Salary (₦)" },
                { key: "net_pay", auto: true, label: "Net Pay (₦)" },
                // { key: "status", auto: true, label: "Status" },
                { key: "total_allowances", auto: true, label: "Total Allowances (₦)" },
                { key: "total_deductions", auto: true, label: "Total Deductions (₦)" },
                { key: "gross_pay", auto: true, label: "Gross Pay (₦)" },
            ],
            sortBy: {
                sort_column: "created_at",
                sort_direction: "desc"
            },
            pageData: {
                data: []
            },
            perPage: 10
        }
    },
    computed:{
        yearOptions() {
            return this.$filters.payrollYearOptions()
        },
        monthOptions() {
            return this.$filters.payrollMonthOptions(this.queryFilters.year)
        },
    },
    methods: {
        navigateTo(id) {
            if (id) {
                this.$router.push({ path: `/payrolls/${id}` })
            }
        },
        updateSearchQuery: _.debounce(function (string) {
            this.fetchItems()
        }, 2000),
        fetchItems(page, per_page = null) {
            let payload = {
                page: page || 1, per_page: per_page || this.itemsPerPage,
                ...this.sortBy, ...this.$filters.validFields(this.queryFilters)
            }
            if (this.searchQuery) { payload.search = this.searchQuery }
            this.isLoading = true
            this.$http.get(`/payrolls?${new URLSearchParams(payload).toString()}`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.pageData = response.data.data
                        this.initializeAll();
                    }
                })
        },
        initializeAll() {
        },
    },
    created() {
        this.fetchItems()
    },
}

</script>